import { render, staticRenderFns } from "./DocumentViewCard2.vue?vue&type=template&id=bc3d997a"
import script from "./DocumentViewCard2.vue?vue&type=script&lang=js"
export * from "./DocumentViewCard2.vue?vue&type=script&lang=js"
import style0 from "./DocumentViewCard2.vue?vue&type=style&index=0&id=bc3d997a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports